module.exports = __webpack_public_path__ + "media/nujabes-mystline-full-version.f11fcc36.mp4";